import React, { memo } from 'react'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import { LOAD_TYPE_OPTIONS } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'

interface ILoadTypeProps {
  loadType: string
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const LoadType = memo<ILoadTypeProps>(({ loadType, onChange }) => {
  const onTypeChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ loadType: value })
  }

  return (
    <div className='row'>
      <div className='col-md-9'>
        <RadioGroup
          label='Load Type'
          required={false}
          name='loadType'
          onOptionChange={onTypeChange}
          checked={loadType}
          options={LOAD_TYPE_OPTIONS}
        />
      </div>
    </div>
  )
})
